import clsx from 'clsx';
import { forwardRef, PropsWithChildren } from 'react';
import { TableCellDivProps } from 'src/core/ui/TableCellDiv';

import * as styles from './BaseCell.css';

export type BaseCellProps = TableCellDivProps & {
  isSelected?: boolean;
  showPadding?: boolean;
  isFullWidth?: boolean;
};

export const BaseCell = forwardRef<
  HTMLDivElement,
  PropsWithChildren<BaseCellProps>
>(function BaseCell(
  {
    children,
    isSelected = false,
    showPadding = true,
    isFullWidth = false,
    style,
    className,
    ...props
  },
  ref
) {
  // Check if children is effectively empty
  const isEmptyValue = !children || children === '';

  const content = isEmptyValue ? (
    <div className={styles.emptyValueBar} />
  ) : (
    children
  );

  // If showPadding is true, render the old simple BaseCell
  if (showPadding) {
    return (
      <div
        ref={ref}
        style={{
          display: 'flex',
          height: '100%',
          padding: '0 8px',
          alignItems: 'center',
          flex: 1,
          width: '100%',
          minWidth: 0,
          justifyContent:
            props.align === 'right'
              ? 'flex-end'
              : props.align === 'center'
                ? 'center'
                : 'flex-start',
          ...style,
        }}
        className={className}
        {...props}
      >
        {content}
      </div>
    );
  }

  // Default behavior with wrapper and content styling
  return (
    <div
      ref={ref}
      style={{
        display: 'flex',
        height: '100%',
        padding: 0,
        alignItems: 'center',
        flex: 1,
        justifyContent: 'center',
        ...style,
      }}
      className={className}
      {...props}
    >
      <div className={styles.wrapper}>
        <div
          className={clsx(
            styles.content,
            isFullWidth && styles.contentFullWidth
          )}
        >
          {content}
        </div>
      </div>
    </div>
  );
});
